import React, { useEffect } from 'react';

import { useUser } from 'app/containers/UserEntityProvider';

const webEngage = (window as any)?.webengage;
const WebEngageProvider = ({ children }: any) => {
    const { user, entity } = useUser();
    const { caUserId, entityId, email, name } = user || {};

    useEffect(() => {
        if (caUserId) {
            webEngage?.user?.login(caUserId);
            webEngage?.user?.setAttribute('entityId', entityId);
            webEngage?.user?.setAttribute('userEmail', email);
            webEngage?.user?.setAttribute('email', email);
            webEngage?.user?.setAttribute('userName', name);
            webEngage?.user?.setAttribute('first_name', name);
            webEngage?.user?.setAttribute('entityName', entity?.companyName);
        }
    }, [caUserId]);

    return <>{children}</>;
};

export default WebEngageProvider;
